import { useMemo } from "react"

export const useTabItems = (metadata, styles) => {
    return useMemo(
        () => [
            {
                key: "published",
                label: (
                    <span>
                        Published <span className={styles.tabCount}>{metadata.published_count || 0}</span>
                    </span>
                )
            },
            {
                key: "drafts",
                label: (
                    <span>
                        Drafts <span className={styles.tabCount}>{metadata.draft_count || 0}</span>
                    </span>
                )
            }
        ],
        [metadata.published_count, metadata.draft_count, styles.tabCount]
    )
}
